import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=223c5590&scoped=true&"
import script from "./Entities.vue?vue&type=script&lang=js&"
export * from "./Entities.vue?vue&type=script&lang=js&"
import style0 from "./Entities.vue?vue&type=style&index=0&id=223c5590&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c5590",
  null
  
)

export default component.exports